<template>
    <vx-card title="Добавление SSP" id="loader">
        <h5 class="mt-5">Основное</h5>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.id"
                        :danger="!!errors.id"
                        :danger-text="errors.id"
                        autocomplete="off"
                        type="number"
                        step="1"
                        min="0"
                        label="SSP ID"
                        class="mt-1 w-full required"/>
                </div>
            </div>

            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название SSP"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Тип рекламы
                </label>
                <v-select :options="dicts.adTypes" label="name" placeholder="Выберите тип рекламы" class="w-full"
                    v-model="form.adTypeId" v-bind:class="{ 'v-select-error': !!errors.adTypeId }"
                    :reduce="a => a.id"
                    @input="loadDictsByAdType()">
                </v-select>
                <div v-if="errors.adTypeId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.adTypeId}}
                    </span>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Группа SSP
                </label>
                <v-select :options="dicts.sspGroups" label="name" placeholder="Выберите группу SSP" class="w-full"
                    v-model="form.sspGroupId" v-bind:class="{ 'v-select-error': !!errors.sspGroupId }" 
                    :reduce="a => a.id">
                </v-select>
                <div v-if="errors.sspGroupId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.sspGroupId}}
                    </span>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Группа SSP (для статистики)
                </label>
                <v-select :options="dicts.sspGroupsStat" label="name" placeholder="Выберите группу SSP (для статистики)" class="w-full"
                    v-model="form.sspGroupStatId" v-bind:class="{ 'v-select-error': !!errors.sspGroupStatId }" 
                    :reduce="a => a.id">
                </v-select>
                <div v-if="errors.sspGroupStatId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.sspGroupStatId}}
                    </span>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Тип оплаты
                </label>
                <v-select :options="dicts.costTypes" label="name" placeholder="Выберите тип оплаты" class="w-full"
                    v-model="form.costTypeId" v-bind:class="{ 'v-select-error': !!errors.costTypeId }"  
                    :reduce="a => a.id">
                </v-select>
                <div v-if="errors.costTypeId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.costTypeId}}
                    </span>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Валюта
                </label>
                <v-select :options="dicts.currencyTypes" label="name" placeholder="Выберите валюту" class="w-full"
                    v-model="form.currencyId" v-bind:class="{ 'v-select-error': !!errors.currencyId }"
                    :reduce="a => a.id">
                </v-select>
                <div v-if="errors.currencyId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.currencyId}}
                    </span>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Тип ротации
                </label>
                <v-select :options="dicts.rotationTypes" label="name" placeholder="Выберите тип ротации" class="w-full"
                    v-model="form.rotationTypeId" v-bind:class="{ 'v-select-error': !!errors.rotationTypeId }"
                    :reduce="a => a.id">
                </v-select>
                <div v-if="errors.rotationTypeId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.rotationTypeId}}
                    </span>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Формат модели
                </label>
                <v-select :options="dicts.modelFormats" label="name" placeholder="Выберите формат модели" class="w-full"
                    v-model="form.modelFormatId"  v-bind:class="{ 'v-select-error': !!errors.modelFormatId }" 
                    :reduce="a => a.id">
                </v-select>
                <div v-if="errors.modelFormatId"
                    class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                    style="height: 19px;">
                    <span class="span-text-validation">
                        {{errors.modelFormatId}}
                    </span>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.cpcCommissionPercent"
                        :danger="!!errors.cpcCommissionPercent"
                        :danger-text="errors.cpcCommissionPercent"
                        autocomplete="off"
                        label="Cpc комиссия, %"
                        class="mt-1 w-full required"/>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.verificationTrafficPercent"
                        :danger="!!errors.verificationTrafficPercent"
                        :danger-text="errors.verificationTrafficPercent"
                        autocomplete="off"
                        label="Верификация, %"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <h5 class="mt-5">Рейтлимиты</h5>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <vs-input
                        v-model="form.rpsLimitRu"
                        :danger="!!errors.rpsLimitRu"
                        :danger-text="errors.rpsLimitRu"
                        autocomplete="off"
                        label="Лимит RPS (RU)"
                        class="mt-1 w-full required"/>
                </div>
            </div>
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <vs-input
                        v-model="form.rpsLimitSing"
                        :danger="!!errors.rpsLimitSing"
                        :danger-text="errors.rpsLimitSing"
                        autocomplete="off"
                        label="Лимит RPS (Sing)"
                        class="mt-1 w-full required"/>
                </div>
            </div>
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <vs-input
                        v-model="form.rpsLimitLatam"
                        :danger="!!errors.rpsLimitLatam"
                        :danger-text="errors.rpsLimitLatam"
                        autocomplete="off"
                        label="Лимит RPS (Latam)"
                        class="mt-1 w-full required"/>
                </div>
            </div>
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <vs-input
                        v-model="form.rpsLimitEu"
                        :danger="!!errors.rpsLimitEu"
                        :danger-text="errors.rpsLimitEu"
                        autocomplete="off"
                        label="Лимит RPS (EU)"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <h5 class="mt-5">Настройка запросов</h5>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <label class="vs-input--label">
                    Типы контента
                </label>
                <v-select :options="dicts.contentTypes" multiple label="name" placeholder="Выберите типы контента" class="w-full"
                    v-model="form.contentTypeIds" :reduce="a => a.id">
                </v-select>
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label">
                    Возрастные рейтинги
                </label>
                <v-select :options="dicts.ageRatings" multiple label="name" placeholder="Выберите рейтинги" class="w-full"
                    v-model="form.ageRatingIds" :reduce="a => a.id">
                </v-select>
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label">
                    Запрещенные тематики
                </label>
                <v-select :options="dicts.adTags" multiple label="name" placeholder="Выберите запрещенные тематики" class="w-full"
                    v-model="form.adTagIds" :reduce="a => a.id">
                </v-select>
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label">
                    Запрещенные браузеры
                </label>
                <v-select :options="dicts.browsers" multiple label="name" placeholder="Выберите запрещенные браузеры" class="w-full"
                    v-model="form.excludedBrowserIds" :reduce="a => a.id">
                </v-select>
            </div>
        </div>

        <h5 class="mt-5">Настройка расчетов</h5>
        <div class="vx-row mb-2">
            <div class="vx-col w-full mt-3 mb-5">
                <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="form.useInMlCalc">Учитывать в ML расчете</vs-checkbox>
            </div>

            <div class="vx-col w-full mb-5">
                <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="form.useInSiteCoeffsCalc">Учитывать в расчете коэффициентов сайтов</vs-checkbox>
            </div>

            <div class="vx-col w-full mb-5">
                <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="form.useInSubscriptionCoeffsCalc">Учитывать в расчете коэффициентов дней подписки</vs-checkbox>
            </div>
        </div>
        

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'ssp-type-create',
    data() {
        return {
            item: undefined,
            form: {
                id: undefined,
                name: undefined,
                adTypeId: undefined,
                sspGroupId: undefined,
                sspGroupStatId: undefined,
                costTypeId: undefined,
                currencyId: undefined,
                rotationTypeId: undefined,
                modelFormatId: undefined,
                cpcCommissionPercent: 0,
                verificationTrafficPercent: 0,
                rpsLimitRu: 0,
                rpsLimitSing: 0,
                rpsLimitLatam: 0,
                rpsLimitEu: 0,
                contentTypeIds: [],
                ageRatingIds: [],
                adTagIds: [],
                excludedBrowserIds: [],
                useInMlCalc: true,
                useInSiteCoeffsCalc: false,
                useInSubscriptionCoeffsCalc: false
            },
            dicts: {
                adTypes: [],
                sspGroups: [],
                sspGroupsStat: [],
                costTypes: [],
                currencyTypes: [],
                rotationTypes: [],
                modelFormats: [],
                contentTypes: [],
                ageRatings: [],
                adTags: [],
                browsers: [],
            },
            errors: {
                id: '',
                name: '',
                adTypeId: '',
                sspGroupId: '',
                sspGroupStatId: '',
                costTypeId: '',
                currencyId: '',
                rotationTypeId: '',
                modelFormatId: '',
                cpcCommissionPercent: '',
                verificationTrafficPercent: '',
                rpsLimitRu: '',
                rpsLimitSing: '',
                rpsLimitLatam: '',
                rpsLimitEu: '',
                contentTypeIds: '',
                ageRatingIds: '',
                adTagIds: '',
                excludedBrowserIds: '',
                useInMlCalc: '',
                useInSiteCoeffsCalc: '',
                useInSubscriptionCoeffsCalc: ''
            }
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'ssp/dicts-create',
                method: 'GET',
                success: (dicts) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.dicts.sspGroups = dicts.sspGroups;
                    this.dicts.sspGroupsStat = dicts.sspGroupsStat;
                    this.dicts.costTypes = dicts.costTypes;
                    this.dicts.currencyTypes = dicts.currencyTypes;
                    this.dicts.rotationTypes = dicts.rotationTypes;
                    this.dicts.adTypes = dicts.adTypes;
                    this.dicts.modelFormats = dicts.modelFormats;
                    this.dicts.contentTypes = dicts.contentTypes;
                    this.dicts.ageRatings = dicts.ageRatings;
                    this.dicts.adTags = dicts.adTags;
                    this.dicts.browsers = dicts.browsers;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                }
            });
        },
        loadDictsByAdType() {
            if (!this.form.adTypeId) {
                return;
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'ssp/dicts-create/' + this.form.adTypeId,
                method: 'GET',
                success: (dicts) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.dicts.sspGroups = dicts.sspGroups;
                    this.dicts.sspGroupsStat = dicts.sspGroupsStat;
                    this.form.contentTypeIds = dicts.sspRequestSettigns.contentTypeIds;
                    this.form.ageRatingIds = dicts.sspRequestSettigns.ageRatingIds;
                    this.form.adTagIds = dicts.sspRequestSettigns.adTagIds;
                    this.form.excludedBrowserIds = dicts.sspRequestSettigns.excludedBrowserIds;
                    
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                }
            });
        },
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                id: this.form.id,
                name: this.form.name,
                adTypeId: this.form.adTypeId,
                sspGroupId: this.form.sspGroupId,
                sspGroupStatId: this.form.sspGroupStatId,
                costTypeId: this.form.costTypeId,
                currencyId: this.form.currencyId,
                rotationTypeId: this.form.rotationTypeId,
                modelFormatId: this.form.modelFormatId,
                cpcCommissionPercent: this.form.cpcCommissionPercent,
                verificationTrafficPercent: this.form.verificationTrafficPercent,
                rpsLimitRu: this.form.rpsLimitRu,
                rpsLimitSing: this.form.rpsLimitSing,
                rpsLimitLatam: this.form.rpsLimitLatam,
                rpsLimitEu: this.form.rpsLimitEu,
                contentTypeIds: this.form.contentTypeIds,
                ageRatingIds: this.form.ageRatingIds,
                adTagIds: this.form.adTagIds,
                excludedBrowserIds: this.form.excludedBrowserIds,
                useInMlCalc: this.form.useInMlCalc,
                useInSiteCoeffsCalc: this.form.useInSiteCoeffsCalc,
                useInSubscriptionCoeffsCalc: this.form.useInSubscriptionCoeffsCalc,
            };

            this.$axios({
                method: 'POST',
                url: 'ssp',
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно добавлено",
                        text: "SSP успешно добавлена",
                        color: "success",
                    });
                    this.$router.push('/ssp-types');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors['']) {
                        const error = err.data.errors[''][0];
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: error,
                            color: "danger",
                        });
                    }

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при добавлении SSP!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/ssp-types');
        }
    },
    mounted() {
        this.loadDicts();
    }
}
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>